<template>
	<BaseCenteredMessage hideLogoutButton class="bg-white">
		<template #icon><BaseIcon name="mono/error" class="w-40 h-40 text-red-500" /></template>
		<template #title><div class="text-gray-500">Access Denied</div></template>
		<template #details>
			<p v-if="!requestedProductAccess" class="text-gray-500">
				You don't have access to Bug capture. Please click on the button below to request admin for access.
			</p>
			<p v-else class="text-gray-500">
				You'll be able to access once the request has been processed by the admin.
			</p>
		</template>
		<template #actions>
			<div class="flex items-center gap-12">
				<BaseButton
					class="button-green"
					:disabled="requestedProductAccess"
					:loading="isLoading"
					@click="requestWorkspaceAccessBrowserstack()"
				>
					Request Access
				</BaseButton>
				<button class="text-gray-400 hover:text-gray-600" @click="logout()">Logout</button>
			</div>
		</template>
	</BaseCenteredMessage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'

export default {
	name: 'RequestWorkspaceAccess',
	props: {
		workspaceId: {type: String, required: true},
	},
	setup() {
		useTitle('Access Denied')
	},
	data() {
		return {
			requestedProductAccess: false,
			isLoading: false,
		}
	},
	methods: {
		async requestWorkspaceAccessBrowserstack() {
			if (this.isLoading) return
			const userData = {
				workspaceId: this.workspaceId,
			}
			// we temporarily set the user's `requestedProductAccess` property to true so we can avoid multiple request creation
			// if the user clicks the button multiple times
			this.requestedProductAccess = true
			this.isLoading = true
			try {
				await this.$api.post('/workspace/request-access', userData)
				this.$notify.success({
					title: 'Access Request Sent',
					message: 'Your request has been sent to the workspace admin.',
				})
			} catch (error) {
				this.requestedProductAccess = false
				this.$notify.error({
					title: 'Request Failed',
					message: 'An error occurred while sending your request. Please try again later.',
				})
			} finally {
				this.isLoading = false
			}
		},
		async logout() {
			await this.$auth.logout()
		},
	},
}
</script>
